import type { NextPage } from 'next';
import Image from 'next/image';
import styles from './jet-card.module.scss';
import Button1 from './Components/Button1/Button1';
import FooterButton from '../Footer/components/FooterButton/FooterButton';
import { JetCardType } from '@/types/jetCard.types';

const JetCard: NextPage<JetCardType> = ({
  className = '',
  device = 'Desktop',
  title,
  text,
  image,
  imageMob,
  buttonFooterText,
  buttonFooterLink,
  button1Text,
  button1Link,
  showCallCta,
}) => {
  return (
    <section className={`container `}>
      <div className={styles.containerJetCard}>
        <div
          className={[styles.jetcard, className].join(' ')}
          data-device={device}
        >
          <div className={styles.textandbuttons}>
            <div className={styles.contentArea}>
              <h2
                className={styles.title}
                dangerouslySetInnerHTML={{
                  __html: title || '',
                }}
              ></h2>
              <div
                className={styles.descriptor}
                dangerouslySetInnerHTML={{
                  __html: text || '',
                }}
              ></div>
            </div>
            <div className={styles.buttons}>
              {buttonFooterText && buttonFooterLink && (
                <FooterButton
                  className={styles.footerButton}
                  color="accent"
                  highContrast={false}
                  loading={false}
                  size={3}
                  state="default ✦"
                  variant="solid ✦"
                  text={buttonFooterText}
                  iconStart={false}
                  iconEnd={false}
                  focusRing={false}
                  href={buttonFooterLink}
                />
              )}
              {button1Text && button1Link && (
                <Button1
                  className={styles.button1}
                  text={button1Text}
                  href={button1Link}
                />
              )}
              {showCallCta && (
                <a href="tel:18335934372" className={styles.callCta}>
                  Or call us: 1-833-FLY-HERA
                </a>
              )}
            </div>
          </div>
          <Image
            className={styles.imgdesktopIcon}
            loading="lazy"
            width={482}
            height={299}
            sizes="(max-width: 768px) 100vw, 50vw"
            alt=""
            src={image}
            quality={85}
          />
          <Image
            className={styles.imgtabletIcon}
            loading="lazy"
            width={1124}
            height={601}
            sizes="(max-width: 768px) 100vw, 50vw"
            alt=""
            src={image}
            quality={85}
          />
          <Image
            className={styles.imgmobileIcon}
            loading="lazy"
            width={362}
            height={298}
            sizes="(max-width: 768px) 100vw, 50vw"
            alt=""
            src={imageMob}
            quality={85}
          />
        </div>
      </div>
    </section>
  );
};

export default JetCard;
